module.exports = __webpack_public_path__ + "img/af21542cb6b20d73215a6de383b9b3e4.png";